module.exports = __webpack_public_path__ + "static/media/imagery1.5f372b12.jpg";